module.exports = "/_next/static/images/MapsJettyBackgroundMorowaliNoSand-a4c35e468a092131107ae7feb9cee8d0.png";